'use client'
import {
  context_default
} from "./chunk-BQWR34GS.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/context/root/provider.tsx
import { useState } from "react";
import { useTranslation } from "@wbk/config";
import { jsx } from "react/jsx-runtime";
var WbkTicketingProvider = (_a) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  var _a2, _b2, _c, _d;
  const [state] = useState(props);
  const { t } = useTranslation(["ticketing_booking"]);
  const value = __spreadProps(__spreadValues({}, state), {
    seats: {
      workspace: {
        seatIO: (_a2 = props.seats.workspace) == null ? void 0 : _a2.seatIO,
        seatCloud: (_b2 = props.seats.workspace) == null ? void 0 : _b2.seatCloud
      },
      colorScheme: props.seats.colorScheme ? props.seats.colorScheme : "dark"
    },
    resell: {
      domain: ((_c = props.resell) == null ? void 0 : _c.domain) || "https://resell.webook.com",
      terms: ((_d = props.resell) == null ? void 0 : _d.terms) || t("ticketing_booking:agree_resell")
    }
  });
  return /* @__PURE__ */ jsx(context_default.Provider, { value, children });
};

export {
  WbkTicketingProvider
};
//# sourceMappingURL=chunk-TZQIEFLB.mjs.map